<template>
    <s-card class="dashboard-header-charts__card h-100" style="cursor: initial;">
        <!-- Header Chart Normal -->
        <s-card-header v-if="chart.data != null" :style="loading?'opacity: 0.1;pointer-events: none;':''" :class="hideCanvas ? 'display-flex flex-col' : ''" class="dashboard-header-charts__header border-bottom-0">
            <div v-if="!hideCanvas" class="display-table w-100 mb-1">

                <span v-if="chart.data && chart.data.totalData !== null && chart.data.totalData !== undefined" class="dashboard-header-charts__header-totale">{{new Intl.NumberFormat().format(chart.data.totalData)}}</span>

                <span v-if="chart.data && !isEmpty(chart.data) && chart.data.percentData != null" class="dashboard-header-charts__header-percent">
                    <svg v-if="chart.data.percentData != null && chart.data.percentData < 0" class="mr-1 ml-2" width="12" height="8" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.76246 0.684323L9.28117 0.226011C9.11438 0.0753516 8.91958 4.76837e-07 8.69722 4.76837e-07C8.47027 4.76837e-07 8.27779 0.0753516 8.11946 0.226011L5.00002 3.19558L1.88061 0.226096C1.7223 0.0754371 1.52977 8.61949e-05 1.30291 8.61949e-05C1.08044 8.61949e-05 0.885688 0.0754371 0.718878 0.226096L0.243897 0.684408C0.0812692 0.839112 0 1.0245 0 1.24041C0 1.46035 0.0813591 1.64364 0.243875 1.79025L4.4223 5.76785C4.57641 5.92258 4.76887 6 5 6C5.22679 6 5.42152 5.9226 5.58399 5.76785L9.76244 1.79025C9.92078 1.63951 10 1.45624 10 1.24041C10 1.02853 9.9208 0.843243 9.76246 0.684323Z" fill="#F80060"/>
                    </svg>
                    <svg v-else-if="chart.data.percentData != null && chart.data.percentData >= 0" class="mr-1 ml-2" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11.715 6.37881L11.1374 6.92878C10.9373 7.10958 10.7035 7.2 10.4367 7.2C10.1643 7.2 9.93335 7.10958 9.74335 6.92878L6.00003 3.3653L2.25673 6.92868C2.06676 7.10947 1.83573 7.19989 1.5635 7.19989C1.29653 7.19989 1.06283 7.10947 0.862654 6.92868L0.292677 6.37871C0.097523 6.19306 0 5.97059 0 5.7115C0 5.44758 0.0976309 5.22763 0.29265 5.05169L5.30676 0.278578C5.49169 0.0929079 5.72265 -3.33786e-06 6 -3.33786e-06C6.27215 -3.33786e-06 6.50583 0.0928822 6.70079 0.278578L11.7149 5.05169C11.9049 5.23259 12 5.45251 12 5.7115C12 5.96576 11.905 6.18811 11.715 6.37881Z" fill="#59D07D"/>
                    </svg>
                    <span v-if="chart.data.percentData" :class="chart.data.percentData < 0 ? 'text-danger' : 'text-success'">{{parseInt(new Intl.NumberFormat().format(chart.data.percentData))}}%</span>
                    <span v-else class="pl-2" style="color:#2B4D75;">-</span>
                </span>
            </div>

            <div v-if="hideCanvas" class="display-table w-100 mb-1">
                <span v-if="chart.data && chartType !== 'conversion_rate' && chartType !== 'churn_rate'" class="dashboard-header-charts__header-totale">{{parseInt(chart.data[chartType].toString().replace('%',''))}}{{chartType == 'churn_rate' ? '%' : '' }}</span>
                <span v-else-if="chart.data && chartType == 'churn_rate'" class="dashboard-header-charts__header-totale row no-gutters w-100">
                    <span class="display-table w-100 col-12 pr-2"><span class="small display-table-cell mr-1 font-weight-normal text-secondary">{{'Active users: '}} </span><span>{{Math.ceil(parseInt(chart.data.active_users))}}</span></span>
                    <span class="display-table w-100 col-12 justify-content-right"><span class="small display-table-cell mr-1 font-weight-normal text-secondary">{{'Churned users: '}} </span><span>{{chart.data.churn_rate}}</span><span class="small display-table-cell">({{chart.data.churn_users_count}})</span></span>
                </span>
                <span v-else-if="chart.data && chartType == 'conversion_rate'" class="dashboard-header-charts__header-totale row no-gutters w-100">
                    <span class="display-table w-100 col-12 pr-2"><span class="small display-table-cell mr-1 font-weight-normal text-secondary">{{'Created accounts: '}} </span><span>{{Math.ceil(parseInt(chart.data.all_users))}}</span></span>
                    <span class="display-table w-100 col-12 pr-2 pt-2"><span class="small display-table-cell mr-1 font-weight-normal text-secondary">{{'Active users: '}} </span><span>{{Math.ceil(parseInt(chart.data.active_users))}}</span></span>
                    <span class="display-table w-100 col-12 pr-2 pt-2"><span class="small display-table-cell mr-1 font-weight-normal text-secondary">{{'Trials started: '}} </span><span>{{Math.ceil(parseInt(((chart.data.subscribed_users) / (chart.data.all_users)) * 100 ) )}}%</span> <span class="small display-table-cell">({{chart.data.subscribed_users}})</span></span>
                    <span class="display-table w-100 col-12 justify-content-right pt-2"><span class="small display-table-cell mr-1 font-weight-normal text-secondary">{{'Started paying: '}} </span><span>{{Math.ceil(parseInt(((chart.data.paid_users) / (chart.data.subscribed_users)) * 100 ) )}}%</span><span class="small display-table-cell">({{chart.data.paid_users}})</span></span>

                    <span class="display-table w-100 col-12 pr-2 pt-2"><span class="small display-table-cell mr-1 font-weight-normal text-secondary">{{'Still on trial: '}} </span><span>{{Math.ceil(parseInt(((chart.data.on_trial) / (chart.data.all_users)) * 100 ) )}}%</span> <span class="small display-table-cell">({{chart.data.on_trial}})</span></span>
                    <span class="display-table w-100 col-12 justify-content-right py-2"><span class="small display-table-cell mr-1 font-weight-normal text-secondary">{{'Canceled: '}} </span><span>{{Math.ceil(parseInt(((chart.data.canceled) / (chart.data.all_users)) * 100 ) )}}%</span> <span class="small display-table-cell">({{chart.data.canceled}})</span></span>
                </span>
            </div>

            <div>
            <p v-if="chartType" class="display-inline-block display-table-cell dashboard-header-charts__header-metric pr-2 text-truncate"> {{capitalize(chartType.replace("_"," "))}} <span class="font-size-small">{{chartType == "churn_rate" || chartType == "conversion_rate" ? "(In this period)" : chartType == "active_users" ? "(Lifetime)" : ""}}</span> {{subType ? capitalize(subType.replace("_"," ")) : ""}}<span v-if="chart.data.lastValue != null"> vs {{parseInt(new Intl.NumberFormat().format(chart.data.lastValue)) }} </span> </p>

            </div>
        </s-card-header>

        <!-- Body Chart Normal -->
        <s-card-body v-if="!hideCanvas" v-show="chart.data" class="p-0 dashboard-header-charts__body-chart" style="height: calc(100% - 70px) !important;">
            <canvas :style="loading?'opacity: 0.1;pointer-events: none;':'position:absolute;'" class="w-100 dashboard__body--chart" ref="canvas"></canvas>
        </s-card-body>

        <!-- Body Chart Loader -->
        <s-card-body style="top:0;height:100%;" v-show="loading" class="p-0 dashboard-header-charts__body-chart w-100 text-center">
            <div v-if="loading" class="loader-chart" style="opacity: 1 !important;z-index:8;">
                <s-loader :type="'scalify'"></s-loader>
            </div>
        </s-card-body>

    </s-card>
</template>

<script>

import Chart from 'chart.js';
import moment from 'moment';
export default {
  name: 'mini-chart',

  components:{
  },

  props:['chartType','subType','startDate','endDate','updateDate','hideCanvas'],

  watch:{
    updateDate:{
        deep:true,
        handler(){
            if (this.updateDate != null) {

                this.startDate = this.updateDate.startDate;
                this.endDate = this.updateDate.endDate;
                this.changesInChart();
            }

        }
    }
  },

  data(){
    return{
      loading:false,
      chart: {
          chartID: null,
          typeChart: 'line',
          showPlatformMetric:false,
          loadingChart: false,
          chartcanvas: null,
          showMetric: false,
          data:null,
          topDropDownMetrics: 20,
          listSelected: [],
          settingMetric: false,
          metric: null
      },
      dataChart: null,
      colorsChart: {"status":"#3C87FF","last_check":"#874FFD","action_taken":"#FFC04B" ,"accounts":"#3C87FF","subscriptions":"#874FFD","tasks":"#FFC04B","charges":"#E65D5B","Created":"#3C87FF","Failed":"#874FFD","Prospecting":"#3C87FF","Custom Conversion":"#874FFD","Audience":"#FFC04B","dpa":"#E65D5B","Scaling":"#3C87FF","Manual Retargeting":"#874FFD","Retention":"#3C87FF"},
      backgroundChart: {"status":"rgba(60, 135, 255, 0.2)","last_check":"rgba(135, 79, 253, 0.2)","action_taken":"rgba(255, 192, 75, 0.2)",  "accounts":"rgba(60, 135, 255, 0.2)","subscriptions":"rgba(135, 79, 253, 0.2)","tasks":"rgba(255, 192, 75, 0.2)","charges":"rgba(230, 93, 91, 0.2)","Created":"rgba(60, 135, 255, 0.2)","Failed":"rgba(135, 79, 253, 0.2)","Prospecting":"rgba(60, 135, 255, 0.2)","Custom Conversion":"rgba(135, 79, 253, 0.2)","Audience":"rgba(255, 192, 75, 0.2)","dpa":"rgba(230, 93, 91, 0.2)","Scaling":"rgba(60, 135, 255, 0.2)","Manual Retargeting":"rgba(135, 79, 253, 0.2)","Retention":"rgba(60, 135, 255, 0.2)"},
      currentChart:null
    }
  },
  methods:{
      async changesInChart(){
        if (this.chart.chartcanvas != null || this.hideCanvas) {
            this.loading = true;
            try{

                let metric = this.chartType;

                let chartData = null
                if(this.hideCanvas){
                    let start = moment(this.startDate).format('YYYY-MM-DD')
                    let end = moment(this.endDate).format('YYYY-MM-DD')
                    let endpoint = `/analytics/${metric}?token=${this.scalifyAccessToken}${`&start=${start}&end=${end}`}`
                    chartData = await this.getCharts(null, null, null, null,endpoint)
                    console.log('chartData Monitor: ', chartData);
                    if(chartData && chartData.duration){
                        delete chartData.duration;
                    }
                    this.chart.data = {...chartData}
                }
                else{
                    chartData = await this.getCharts(metric, this.startDate, this.endDate, this.subType)

                    // console.log('metric: ', metric);

                    this.chart.data = {dataLabel:chartData.label, dataCharts:chartData.data, lastValue:null, totalData:chartData.total, percentData:null}
                    // this.chart.data = {dataLabel:data.dataLabel, dataCharts:data.dataCharts,lastValue:data.lastValue, totalData:data.totalData, percentData:data.percentData}

                    this.dataChart.labels = this.chart.data.dataLabel;
                    this.dataChart.datasets[0].data = this.chart.data.dataCharts;

                    this.chart.chartcanvas.update();
                }

                this.loading = false;
            }
            catch(err){
                this.loading = false;
            }

        }
    },
  },

  async mounted(){

    this.loading = true
    this.chart.loadingChart = true;

    this.chart.chartID = this.$refs.canvas;
    try{

        let metric = this.chartType;
        let chartData = null;
        // console.log('metric: ', metric);
        // let chartData = await this.getCharts(metric, this.startDate, this.endDate, this.subType)
        if(this.hideCanvas){
            let start = moment(this.startDate).format('YYYY-MM-DD')
            let end = moment(this.endDate).format('YYYY-MM-DD')
            let endpoint = `/analytics/${metric}?token=${this.scalifyAccessToken}${`&start=${start}&end=${end}`}`
            chartData = await this.getCharts(null, null, null, null,endpoint)
            
            console.log("khbaaar khaaaayba "+metric,chartData)

            if(chartData && chartData.duration){
                delete chartData.duration;
            }
            this.chart.data = {...chartData}
        }
        else{
            chartData = await this.getCharts(metric, this.startDate, this.endDate, this.subType)

            // console.log('this.backgroundChart[this.chartType]: ', this.backgroundChart[this.chartType])
            // console.log('this.backgroundChart[this.subType]: ', this.backgroundChart[this.subType])
            this.chart.data = {dataLabel:chartData.label, dataCharts:chartData.data, lastValue:null, totalData:chartData.total, percentData:null}

            this.dataChart = {
                labels: this.chart.data.dataLabel,
                datasets: [{ data:this.chart.data.dataCharts, borderWidth: 2, borderColor:this.chartType != "task_type" ? this.colorsChart[this.chartType] : this.colorsChart[this.subType], backgroundColor: this.chartType != "task_type" ? this.backgroundChart[this.chartType] : this.backgroundChart[this.subType], label: this.capitalize(this.chartType.replace("_"," ")), lineTension: 0.1,  radius: 0, pointHoverBackgroundColor:this.chartType != "task_type" ? this.colorsChart[this.chartType] : this.colorsChart[this.subType],pointBackgroundColor: this.chartType != "task_type" ? this.colorsChart[this.chartType] : this.colorsChart[this.subType], pointHoverRadius:4, fill:true }]
            }


            this.chart.chartcanvas = new Chart(this.chart.chartID, {
                type: this.chart.typeChart,
                data: this.dataChart,
                options: {
                    layout: { padding: { left: 15, right: 15, top: 10, bottom: 15 } },
                    legend: { display: false },
                    elements: { point:{ radius: 0 }, line: { skipNull: true, drawNull: false, } },
                    tooltips: {
                        mode: 'index', intersect: false,
                        backgroundColor: '#FFFFFF', titleFontFamily: 'Walsheim Pro', titleFontSize: 14, titleFontColor: '#52749C',
                        titleMarginBottom: 10, bodyFontFamily: 'arial' , bodyFontSize: 14, bodyFontColor: '#52749C', bodySpacing: 5, xPadding: 15, yPadding: 15, bodyFontStyle: '500', caretSize: 0, borderColor: 'rgba(42, 140, 255, 0.27)', borderWidth: 1,caretPadding: 10,
                        callbacks: {
                            label: (tooltipItem, data)=> {
                                var label = data.datasets[tooltipItem.datasetIndex].label || '';
                                if (label) {
                                    label += ' ';
                                }
                                label += Math.round(tooltipItem.yLabel * 100) / 100;
                                return label;
                            }
                        },

                    },
                    hover: {
                        mode: 'index',intersect: false,
                        onHover: function(e) {
                            var point = this.getElementAtEvent(e);
                            if (point.length){ e.target.style.setProperty('cursor','pointer','important');
                            }else{ e.target.style.setProperty('cursor','default','important');}
                        }
                    },
                    maintainAspectRatio: false,
                    onResize: ()=>{
                        this.chart.chartcanvas.update();
                    },
                    // responsive: true,
                    scales: {
                        xAxes: [{ ticks: { display: false }, type:"time", time:{ tooltipFormat: 'll'}, gridLines: { display:false, drawBorder: false, tickMarkLength: 0 } }],
                        yAxes: [{ type:'logarithmic', ticks: { display: false, beginAtZero: true }, gridLines: { display:false, drawBorder: false, tickMarkLength: 0 } }]
                    }
                }
            });
        }

        this.chart.loadingChart = false;
    }
    catch(err){
        this.chart.loadingChart = false;
        this.handleErrors(err)
    }

    this.loading = false
  },




}
</script>

<style scoped>

</style>
